module.exports = __webpack_public_path__ + "static/media/elucd-logo-blue.b3e986d9.svg";